export default {
  default_program_name: 'Club de récompenses',
  message:
    'Rejoignez <highlight>{{name}}</highlight> — gagnez {{reward}} pour chaque {{spend}} dépensé et débloquez des articles gratuits !',
  buttons: {
    join_now: 'Rejoindre maintenant',
  },
};
